import React from 'react'
import './Sidebar.css'
import { MdExpandMore } from 'react-icons/md'
import { MdAddCircle } from 'react-icons/md'
import { MdAccountCircle } from 'react-icons/md'
import SidebarChannel from './SidebarChannel'
import { useSelector } from 'react-redux'
import { selectUser } from './features/userSlice'
import { auth } from './firebase'
import { db } from './firebase'
import { useEffect, useState } from 'react'
import { addDoc, onSnapshot, collection } from "firebase/firestore"

function Sidebar() {
    const user = useSelector(selectUser)
    const [channels, setChannels] = useState([]);

    useEffect(() => {
        onSnapshot(collection(db, "channels"), (snapshot) =>
        setChannels(
            snapshot.docs.map((doc) => ({
                id: doc.id,
                channel: doc.data(),
                }))
            )
        );
    }, [])

    const handleAddChannel = () => {
        const channelName = prompt("Enter a new channel name");

        if (channelName) {
            addDoc(collection(db, "channels"), {
                channelName: channelName,
            });
        }
    }; 

  return (
    <div className='sidebar'>
        <div className='sidebar__top'>
            <h3>Logan's Message Space</h3>
        </div>
        <div className='sidebar__channels'>
            <div className='sidebar__channelsHeader'>
                <div className='sidebar__header'>
                    <MdExpandMore />
                    <h4>Channels</h4>
                </div>
                <MdAddCircle onClick={handleAddChannel} className='sidebar__addChannel' />
            </div>
            <div className='sidebar__channelsList'>
                {channels.map(({id, channel}) => (
                <SidebarChannel
                key = {id}
                id = {id}
                channelName = {channel.channelName}
                />
                ))}
            </div>
            
        </div>
        <div className='sidebar__profile'>
            <div className='sidebar__profileInfo'> 
            { user.photo ? <img src={user.photo} alt="" /> : <MdAccountCircle />}
            <h3>{user.displayName}</h3>
            <div onClick={() => auth.signOut()} className='sign-out'>
                <p>Sign Out</p>
            </div>
            </div>
        </div>
    </div>
  )
}

export default Sidebar